import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as Ariakit from '@ariakit/react';
import * as React from 'react';
import * as Styles from './styles';
import { useExpansionPanelState } from '.';
export const Summary = React.forwardRef(function ExpansionPanelSummary({ children, expandIcon, disabled, ...rest }, ref) {
    const state = useExpansionPanelState();
    const icon = React.useMemo(() => {
        return !expandIcon
            ? null
            : typeof expandIcon === 'function'
                ? expandIcon(state?.open ?? false)
                : expandIcon;
    }, [expandIcon, state?.open]);
    return (_jsxs(Ariakit.Disclosure, { render: _jsx(Styles.Summary, { ref: ref, ...rest }), disabled: disabled, accessibleWhenDisabled: true, children: [typeof children === 'function' ? children(state?.open ?? false) : children, icon] }));
});
//# sourceMappingURL=Summary.js.map